module.exports = __webpack_public_path__ + "img/20200508_163228.290efb3c.jpg";